import { memo } from "react"

import { ComponentProps } from "."
import Header from "./Header"
import List from "./List"
import { Wrapper } from "./styled"

const Content = ({
  avatar,
  display,
  flagLoading,
  isShowFlagButton,
  label,
  name,
  onSelect,
  onToggleFlagged,
  selected,
  subheader,
  title
}: ComponentProps) => (
  <Wrapper>
    <Header avatar={avatar} subheader={subheader} title={title} />

    <List
      display={display}
      flagLoading={flagLoading}
      isShowFlagButton={isShowFlagButton}
      label={label}
      name={name}
      onSelect={onSelect}
      onToggleFlagged={onToggleFlagged}
      selected={selected}
    />
  </Wrapper>
)

Content.whyDidYouRender = true

export default memo(Content)
